import actions from './actions';

const initState = {
	dataGetSampleExam: {},
	dataGetSampleExamById: null,
	totalItems: 0,
	dataGetQuestionForCreate: null,
	idForUpdate: [],
	dataSpecialStudents: [],
	specialStudent: null,
};

export default function reducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_SAMPLE_EXAM_SUCCESS: {
			return { ...state, dataGetSampleExam: action.payload.data };
		}

		case actions.GET_SAMPLE_EXAM_BY_ID_SUCCESS: {
			return { ...state, dataGetSampleExamById: action.payload };
		}

		case actions.GET_QUESTION_FOR_CREATE_SUCCESS: {
			return { ...state, dataGetQuestionForCreate: action.payload.data };
		}

		case actions.GET_SPECIAL_STUDENTS_MOCKTEST_SUCCESS: {
			return { ...state, dataSpecialStudents: action.payload.data };
		}

		case actions.GET_SPECIAL_STUDENTS_MOCKTEST_BY_ID_SUCCESS: {
			return { ...state, specialStudent: action.payload };
		}

		case actions.LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
